export default __webpack_public_path__ + "static/atlassian-navigation.light-60205d30b445d46138494cc1bbbeafdc1bb55d7990a42b98151ec4cbc55532cf.png";